import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import { initSentry } from './lib/sentry';
import { ErrorFallback } from './components/common/ErrorFallback';
import './index.css';
import App from './App';

initSentry();

const AppWithSentry = Sentry.withErrorBoundary(App, {
  fallback: <ErrorFallback />,
});

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <AppWithSentry />
  </StrictMode>,
);
